import { supabase } from "@/integrations/supabase/client";
import { saveChildProfile } from "@/lib/supabase/profile";
import { logger } from '@/lib/logger';

type AuthDestination = "dashboard" | "quiz";

export async function ensureUserScaffolding(userId: string, email: string) {
  const normalizedEmail = email.toLowerCase();
  const defaultName = normalizedEmail.split("@")[0] ?? "Parent";

  try {
    // Check if profile already exists with a custom name
    const { data: existingProfile } = await supabase
      .from("profiles")
      .select("name")
      .eq("id", userId)
      .maybeSingle();

    // Only scaffold if profile doesn't exist or has no name set
    // Don't overwrite user-customized names!
    if (!existingProfile || !existingProfile.name || existingProfile.name === defaultName) {
      await saveChildProfile({
        parentName: defaultName,
        email: normalizedEmail,
      });

      // Scaffolding log suppressed — fires multiple times per auth state change
    } else {
      // Skip scaffold log suppressed
    }
  } catch (error) {
    logger.error(`Failed to scaffold profile information for user ${userId}`, error);
  }
}

export async function resolveAuthDestination(userId: string): Promise<AuthDestination> {
  try {
    const { data: progressData, error } = await supabase
      .from("user_progress")
      .select("quiz_completed")
      .eq("user_id", userId)
      .maybeSingle();

    if (error && error.code !== "PGRST116") {
      logger.error(`Error fetching user progress for ${userId}`, error);
      return "dashboard";
    }

    return progressData?.quiz_completed ? "dashboard" : "quiz";
  } catch (error) {
    logger.error(`Unexpected error resolving destination for ${userId}`, error);
    return "dashboard";
  }
}
